import type { IntegrationApplication } from '@wix/members-area-integration-kit';

export const WISHLIST_PAGE_ID = 'wishlist';

export const isMyWishlist = (app: IntegrationApplication) => app.pageId === WISHLIST_PAGE_ID;
